<template>
  <base-button class="btn-dark" text="キャンセル" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'CancelButton',
  components: {
    BaseButton,
  },
}
</script>
